var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 31.68,
    viewBox: "0 0 3.456 2.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    d: "M0 0h3.456v2.737H0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    d: "M0 2.042h3.455v.695H0Zm0-2.04h3.455v.693H0Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d1d3",
    fillRule: "evenodd",
    d: "M1.219 1.78h.171v.074H1.22Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b7a96",
    fillRule: "evenodd",
    d: "M1.39 1.85v.015a.077.077 0 0 1-.055-.007.085.085 0 0 0-.059 0 .077.077 0 0 1-.057.004v-.014a.08.08 0 0 0 .059-.004c.015-.009.04-.005.057 0 .019.006.037.012.055.006zm0-.037v.015a.092.092 0 0 1-.055-.008.102.102 0 0 0-.059 0 .09.09 0 0 1-.057.004V1.81a.094.094 0 0 0 .059-.004c.015-.008.04-.004.057 0 .019.007.037.01.055.007zm0-.038v.015a.092.092 0 0 1-.055-.007.102.102 0 0 0-.059 0 .121.121 0 0 1-.057.005v-.016a.08.08 0 0 0 .059-.004.122.122 0 0 1 .057 0c.019.007.037.012.055.007z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d1d3",
    fillRule: "evenodd",
    d: "M.412 1.78h.172v.074H.412Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b7a96",
    fillRule: "evenodd",
    d: "m.411 1.813.003.015c.017.004.039 0 .056-.008a.098.098 0 0 1 .058 0 .09.09 0 0 0 .057.004V1.81a.09.09 0 0 1-.057-.004c-.017-.008-.043-.004-.06 0a.105.105 0 0 1-.057.007zm0 .037.003.015c.017.005.039.002.056-.007a.082.082 0 0 1 .058 0c.02.01.039.01.057.004v-.014a.077.077 0 0 1-.057-.004c-.017-.009-.043-.005-.06 0a.088.088 0 0 1-.057.006zm0-.075.003.015c.017.005.039 0 .056-.007a.098.098 0 0 1 .058 0c.02.007.039.007.057.005v-.016a.077.077 0 0 1-.057-.004.127.127 0 0 0-.06 0c-.016.007-.035.012-.057.007z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.003456,
    d: "M.867 1.602v.17l-.028.025v-.222c.008.01.018.02.028.027zM.78 1.5v.326l.026-.01V1.5Zm-.029 0v.335l-.03-.013V1.5zm-.062.303v-.303H.66v.276l.029.027z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.632 1.43v-.058c-.06-.023-.185-.015-.233.033-.004.012.015.051.02.056.031-.047.154-.062.213-.03z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.42 1.46c.01.013.022.025.036.027"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.543 1.445c.008.002.026.013.028.021-.026.04-.108.064-.16.096-.01.02-.003.046.004.053.054-.032.145-.071.161-.098.002-.004.003-.038-.005-.05a.071.071 0 0 0-.028-.022z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.433 1.605c.013.007.02.041.005.039a.157.157 0 0 0-.022-.029z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.286 1.415v.093m0-.253v.107"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#c6aa6a",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.367 1.742v.036h-.123v-.036zm-.025-.016.014.016h-.104l.016-.016zm.004-.01H1.26s-.003.002-.003.006.002.004.003.004h.085c.004 0 .005 0 .005-.004s0-.006-.005-.006z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.266 1.547v.17h.08V1.59l-.08-.044zm.08-.116v.105c-.028-.012-.053-.027-.081-.04v-.084c.02 0 .055.006.08.019zm-.002-.176v.116a.305.305 0 0 0-.078-.01v-.106z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#c6aa6a",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.344 1.243v.012h-.078v-.012zm.014-.02-.015.02h-.077l-.016-.02Zm.005-.032h-.117v.031h.117zm-.925.55v.037H.56v-.036zm.025-.015-.016.016h.105l-.015-.016zm-.006-.01h.084c.003 0 .006.002.006.006s-.003.004-.006.004H.457c-.003 0-.004 0-.004-.004s0-.006.004-.006z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.54 1.547v.17H.457V1.59c.026-.015.055-.027.081-.044zm-.083-.114v.106c.028-.015.058-.028.082-.043v-.081c-.028.003-.055.005-.082.018zm.003-.178v.116a.3.3 0 0 1 .08-.01v-.106zm0-.012v.012h.08v-.012z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#c6aa6a",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "m.447 1.222.014.021h.078l.015-.02zm-.007-.03h.118v.03H.44z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.528 1.255v.107m.005-.107v.107m.798-.107v.107m.008-.107v.107m-.811.053v.087m.005-.087v.087m.798-.087v.087m.008-.087v.087m-.811.053v.16m.005-.16v.16m.798-.16v.16m.008-.16v.16"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "m1.178 1.425.002-.055c.06-.023.178-.013.228.035.003.012-.015.051-.02.056-.032-.047-.148-.068-.21-.036z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.387 1.46c-.01.012-.025.027-.04.03"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.261 1.446c-.008.002-.024.012-.026.02.026.04.108.064.16.096.01.02.004.046-.003.053-.056-.032-.146-.071-.162-.098-.002-.004-.004-.038.005-.05a.06.06 0 0 1 .026-.021zM1.372 1.605c-.011.007-.018.041-.003.039a.157.157 0 0 1 .021-.029z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#fff22d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "m.439 1.434-.017-.038c.009-.006.022-.014.03 0 .003.007 0 .015-.017.021l.007.015zm-.013-.037.007.015c.01-.002.02-.008.014-.016-.005-.008-.013-.002-.02.001zm.05.015.018-.004.001.003-.02.007-.013-.042h.005zM.53 1.41l-.02-.04h.005l.017.035.013-.037H.55l-.015.042zm.041-.014c0 .015.02.01.015-.002 0-.005-.02-.006-.016-.019.001-.005.012-.011.021-.004.002 0 .002.005.002.009L.59 1.378c-.002-.01-.015-.008-.015-.003-.002.012.015.004.017.021.001.003-.001.014-.014.013-.007 0-.014-.008-.012-.014zm.793-.007.005.002-.002.04-.003-.002v-.013l-.016-.007-.01.009-.004-.001zm0 .005-.014.012.014.006zm-.066.014.01-.036c.016.002.024.007.021.017 0 .006-.005.01-.012.01l.005.014H1.32l-.01-.02c.011.002.015.002.017-.005.003-.01-.012-.011-.015-.011l-.01.032zm-.023-.003.004-.034-.01-.001.002-.002.02.002v.002l-.009-.001-.003.034h-.004zM1.241 1.4l.016-.001v.003l-.019.002-.003-.035.003-.002Zm-.028.008-.023-.034h.005l.02.03.006-.035h.004l-.008.039z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.003456,
    d: "M.899 1.2h.282v.3H.899Z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#c6aa6a",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004816,
    d: "m1.098 1.255.02-.005-.012-.008.002-.01-.011-.003V1.22l-.013.001-.007-.01-.01.004-.007-.005.006.023c.018-.002.018.009.032.022z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.003456,
    d: "M.634 1.2h.263v.299H.634Z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.706 1.34h.126v.076l.011.01a.125.125 0 0 0-.02.037H.69v-.044h.017zm-.008-.037v.037h.138V1.3h-.02l-.002.019H.797v-.017H.774v.016H.76v-.016H.74v.018H.723v-.017z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#505e86",
    fillRule: "evenodd",
    stroke: "#fff22d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.78 1.388h.04V1.36c0-.013-.04-.013-.04 0zm-.067 0h.04V1.36c0-.013-.04-.013-.04 0z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.003456,
    d: "M.897 1.73c-.038.061-.072.089-.15.1.092.033.153.043.304.005a.262.262 0 0 1-.154-.105z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5a773",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.897 1.766c.015 0 .028.014.028.03 0 .017-.013.031-.028.031-.016 0-.028-.014-.028-.031a.03.03 0 0 1 .028-.03z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#598376",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.912 1.84c0-.018.03-.022.043-.01-.012.01-.029.026-.043.01z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.888 1.826a.024.024 0 0 1 0 .028h.023C.9 1.847.903 1.832.905 1.826c-.002.002-.012.002-.017 0z",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#598376",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.835 1.826c.017.015.031.016.053.016-.024-.025-.039-.026-.053-.016z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.895 1.778c.008 0 .013.008.013.018 0 .01-.005.016-.013.016-.006 0-.011-.007-.011-.016 0-.01.005-.018.011-.018z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.719 1.28v.04h.02l.002-.04zm.076 0v.04h.02v-.04zm-.038-.031v.071h.018V1.25zm-.012-.023v.023h.042v-.023H.779v.01H.77v-.01H.76v.01H.755v-.01zm-.037.032v.022H.75v-.022H.742v.01H.734v-.01h-.01v.01H.719v-.01zm.077.001v.02h.04v-.021H.817v.01H.809V1.26H.802v.01h-.01v-.01z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.005872,
    d: "M.73 1.168c0 .037.337.04.343-.003-.025-.048-.333-.045-.343.003Z",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.003456,
    d: "M1.152.999c-.002-.035-.071-.06-.118-.03C1.011.935.95.919.9.949.869.918.798.923.772.964.732.941.658.962.658 1.011c.03.121.054.106.069.103a.903.903 0 0 1 .356.003c.036.004.063-.057.069-.118z",
    clipRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.005872,
    d: "M.745 1.166c.044-.038.288-.024.304-.001.004.032-.317.025-.304 0z",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.005872,
    d: "m1.071 1.166.012-.04a.94.94 0 0 0-.36 0l.006.04c.021-.047.33-.044.342 0z",
    clipRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.72 1.112c-.008.003-.01.014.006.012a.918.918 0 0 1 .35.002.009.009 0 0 0 .01-.003c0-.002-.002-.008-.011-.011a1.045 1.045 0 0 0-.355 0Zm-.038-.03c-.005-.001-.006 0-.006.002 0 .016.021.035.04.032.006-.005.021-.018.021-.024.012.014.045.017.045-.01.008.016.04.026.062-.003.021.019.04.019.058.002.01.009.04.023.063-.003.012.022.035.028.051.012.014.016.03.022.05.012.016.002.01.021.027.015.008 0 .029-.016.028-.03-.038.035-.036.013-.043 0-.02.01-.046.022-.06-.014-.022.02-.038.014-.045-.018-.008.016-.048.05-.069-.003-.008.029-.04.04-.06.012-.005.007-.033.045-.06 0-.013.03-.028.038-.049.007-.006.033-.035.043-.053.012zM.9.9C.903.899.905.9.905.904S.903.91.9.91.895.907.895.904.897.9.9.9zm0 .018c.004 0 .007.001.007.005C.907.924.904.927.9.927.897.927.894.924.894.922.894.918.897.917.9.917zm0 .016c.005 0 .009.004.009.008 0 .005-.004.007-.01.007C.897.948.893.946.893.941.892.937.896.933.9.933zm0 .02c.008 0 .012.005.012.01C.912.97.908.973.9.973.894.972.888.968.888.962c0-.005.006-.01.012-.01zm.275.065c-.008 0-.014.006-.014.012s.006.011.014.011c.007 0 .013-.005.013-.011 0-.006-.006-.012-.013-.012zm.01-.03c-.008 0-.013.004-.013.01 0 .007.005.011.012.011s.014-.004.014-.011c0-.006-.007-.01-.014-.01zM1.187.96c-.008 0-.014.004-.014.01 0 .007.006.013.014.013.007 0 .014-.006.014-.013 0-.006-.007-.01-.014-.01zM1.18.932c-.008 0-.014.006-.014.011 0 .006.006.012.014.012.007 0 .014-.006.014-.012 0-.005-.007-.011-.014-.011zM1.155.91c-.008 0-.013.006-.013.012 0 .007.005.011.013.011.006 0 .013-.004.013-.011 0-.006-.007-.012-.013-.012zM1.127.902c-.007 0-.013.005-.013.01 0 .007.006.012.013.012.007 0 .013-.005.013-.012 0-.005-.006-.01-.013-.01zM1.099.897c-.007 0-.013.005-.013.012 0 .006.006.011.013.011.007 0 .014-.005.014-.011 0-.007-.007-.012-.014-.012zM1.074.895c-.008 0-.014.006-.014.012 0 .005.006.011.014.011.005 0 .012-.006.012-.011 0-.006-.007-.012-.012-.012zm-.04.083c-.004 0-.009.002-.009.008 0 .005.005.008.01.008.004 0 .01-.003.01-.008 0-.006-.006-.008-.01-.008zm.007-.02c-.004 0-.009.004-.009.009 0 .004.005.008.01.008.004 0 .009-.004.009-.008 0-.005-.005-.009-.01-.009zm.007-.024c-.005 0-.01.005-.01.01s.005.01.01.01c.006 0 .012-.005.012-.01s-.006-.01-.012-.01zM1.045.905c-.006 0-.012.005-.012.01 0 .007.006.01.012.01s.01-.003.01-.01c0-.005-.004-.01-.01-.01zm-.02-.023c-.009 0-.015.005-.015.012s.006.011.014.011c.006 0 .013-.004.013-.011 0-.007-.007-.012-.013-.012zM.992.871C.986.87.979.876.979.88c0 .007.007.013.014.013s.014-.006.014-.013c0-.005-.007-.01-.014-.01zM.964.867C.957.867.952.873.952.88c0 .007.005.011.012.011S.978.886.978.88C.978.873.971.867.964.867zM.937.87C.929.869.923.873.923.88c0 .007.006.012.014.012C.942.892.95.887.95.88S.942.87.937.87zm-.073 0c.007 0 .013.004.013.011C.877.887.87.892.864.892.857.892.851.887.851.88S.857.87.864.87zM.836.867C.843.867.85.873.85.88.849.886.843.89.836.89.83.89.824.886.824.88c0-.006.005-.012.012-.012zM.808.871C.814.87.82.876.82.88a.013.013 0 0 1-.012.013A.013.013 0 0 1 .795.88c0-.005.006-.01.013-.01zM.776.882C.785.882.79.887.79.894S.785.905.776.905A.012.012 0 0 1 .765.894C.765.887.77.882.776.882zm-.02.023c.005 0 .01.005.01.01 0 .007-.005.01-.01.01-.006 0-.01-.003-.01-.01 0-.005.004-.01.01-.01zM.75.935c.007 0 .012.004.012.008 0 .006-.005.01-.012.01-.006 0-.01-.004-.01-.01a.01.01 0 0 1 .01-.009zM.76.957c.005 0 .01.004.01.009 0 .004-.005.008-.01.008C.755.975.75.97.75.967.75.962.755.958.76.958zm.007.02c.005 0 .008.002.008.008a.008.008 0 0 1-.008.008C.76.994.756.991.756.986.757.98.76.978.767.978zM.726.895c.009 0 .015.006.015.012C.74.912.735.918.727.918.72.918.714.912.714.907.714.9.72.895.727.895zM.7.897c.008 0 .014.005.014.012C.714.915.708.92.7.92A.012.012 0 0 1 .69.91C.689.902.695.897.7.897zM.674.902c.007 0 .013.005.013.01C.687.92.68.924.674.924.667.924.66.919.66.912c0-.005.007-.01.014-.01zM.62.932c.007 0 .012.006.012.011C.632.95.627.955.62.955S.607.949.607.943C.607.938.613.932.62.932zM.645.91C.653.91.66.916.66.922c0 .007-.006.011-.014.011C.638.933.632.93.632.922.632.916.638.91.645.91zM.616.987c.007 0 .013.005.013.01 0 .008-.006.012-.013.012-.007 0-.012-.004-.012-.011 0-.006.005-.01.012-.01zM.613.961C.62.96.627.965.627.97.627.978.62.984.613.984A.013.013 0 0 1 .6.97c0-.006.006-.01.013-.01zm.013.057c.006 0 .012.006.012.012s-.006.011-.012.011c-.007 0-.013-.005-.013-.011 0-.006.006-.012.013-.012zm.525.02-.01-.027C1.199.957 1.118.917 1.06.93l-.001-.01c.054 0 .156.02.088.094l.01.021zm-.127-.032-.013-.03C1.064.917.96.88.927.91V.9c.046-.031.149.017.093.078l.011.017zM.927.91C.925.933.911.961.937.98L.912.998.91.992.925.98C.908.958.917.92.927.9zm-.055 0C.876.933.89.961.866.98L.89.998.892.992.876.98C.894.958.884.92.872.9zm-.096.095.012-.03C.738.917.84.88.873.91V.9C.826.87.725.918.78.979L.77.995zm-.127.032.009-.027C.602.957.683.917.74.93v-.01c-.052 0-.154.02-.088.094l-.01.021zM.904.833c.034.022.019.045 0 .063C.893.886.882.881.882.864.884.849.888.84.904.833zM.905.87V.82h.013V.814H.905v-.01H.9v.012H.887V.82H.9V.87H.882l.002.004H.92L.923.87z",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.182 1.066c-.01-.022-.043-.026-.05-.002-.004.007-.012.002-.021-.004.003.007.002.01-.004.011l-.014.002.012.01c-.004.002-.01.004-.012.008.006-.001.023-.005.03-.002 0-.03.046-.023.059-.023zm-.138.01-.005-.012.023-.003-.02-.008.012-.01h-.026l.013-.025-.016.003-.005-.015-.01.014-.014-.007.005.027-.022-.008.007.014-.02.003.018.01-.008.009.029.001zm-.14-.024-.041.007.008-.01-.032-.012.03-.006-.01-.016.028.013L.876.99l.016.008L.9.976l.01.023.015-.012-.008.043.031-.01-.015.014.029.009-.025.008.005.012zm-.158.018L.75 1.06l-.023-.004.02-.008-.012-.01.028.001-.014-.025.015.002L.767 1l.012.013.012-.006-.005.027.022-.008-.006.014.02.004-.019.009.008.01H.782zm-.124-.012c.01-.022.042-.026.05-.002.003.007.011.002.02-.004-.003.007-.002.009.004.011l.012.001-.008.01c.003.003.008.005.01.009C.706 1.08.69 1.077.68 1.08c0-.03-.045-.023-.058-.023z",
    clipRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.67 1.068c-.017 0-.02.005-.016.015.01.007.021.003.021-.01 0-.004-.005-.005-.006-.005z",
    clipRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.727 1.058c-.027 0-.002.032.008.01 0-.006-.005-.01-.008-.01z",
    clipRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.772 1.036c-.01.009-.005.028.013.022.013-.007-.009-.024-.013-.022z",
    clipRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.843 1.04c-.007-.004-.018.006-.012.013.02.016.024-.006.012-.014z",
    clipRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.907 1.026c-.004 0-.017 0-.018.007 0 .013.018.019.026.008 0-.007-.003-.011-.008-.015z",
    clipRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.965 1.043c-.028 0 0 .028.01.009 0-.003-.005-.01-.01-.01z",
    clipRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.016 1.043c.01.008.007.026-.014.021-.011-.008.008-.023.014-.021z",
    clipRule: "evenodd"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.076 1.064c.025 0 0 .03-.008.009 0-.005.001-.009.008-.009z",
    clipRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.132 1.077c.018 0 .022.006.018.013-.007.009-.022.004-.022-.01 0-.003.003-.003.004-.003z",
    clipRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.761 1.127c.005-.001.01 0 .01.004s-.003.008-.007.008c-.005.003-.01 0-.01-.002 0-.005.003-.008.007-.01zm.278 0c-.003-.001-.007 0-.008.004 0 .004.002.008.007.008.003.003.007 0 .007-.002.001-.005-.002-.008-.006-.01zm-.184-.01c.003 0 .007.004.007.007a.007.007 0 0 1-.007.007.007.007 0 0 1-.007-.007c0-.003.003-.007.007-.007zm.095-.003c-.004 0-.008.003-.008.007 0 .003.004.006.008.006s.007-.003.007-.006a.007.007 0 0 0-.007-.007Z",
    clipRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#33a457",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.808 1.119c.013-.002.024 0 .025.003 0 .004-.01.008-.024.01-.013.002-.024 0-.024-.003-.002-.003.009-.008.023-.01zm.188 0c-.012-.002-.024 0-.024.003 0 .004.01.008.023.01.014.002.025 0 .026-.003 0-.003-.01-.008-.025-.01z",
    clipRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.903 1.112c.013 0 .024.004.024.008 0 .003-.011.006-.025.006-.014-.002-.024-.004-.024-.009 0-.003.011-.005.025-.005zm-.178.02-.012.013.014.008.011-.014zm.356 0 .01.013-.014.008-.011-.014z",
    clipRule: "evenodd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.005872,
    d: "M1.265 1.185c0 .01.08.01.08 0-.005-.011-.078-.01-.08 0z",
    clipRule: "evenodd"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.003456,
    d: "M1.364 1.146c0-.009-.016-.015-.028-.007-.004-.008-.02-.012-.03-.005-.008-.007-.025-.006-.03.004-.01-.007-.028-.001-.028.01.008.028.013.026.016.025a.208.208 0 0 1 .084 0c.008.002.015-.013.016-.027z",
    clipRule: "evenodd"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.005872,
    d: "M1.268 1.185c.01-.009.068-.005.072 0 0 .007-.075.006-.072 0z",
    clipRule: "evenodd"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.005872,
    d: "m1.344 1.184.004-.008a.193.193 0 0 0-.085 0l.002.008c.005-.01.077-.009.08 0z",
    clipRule: "evenodd"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.263 1.172c-.002 0-.003.003 0 .003a.201.201 0 0 1 .084 0h.002s-.001-.002-.003-.002a.252.252 0 0 0-.083-.001zm-.01-.006c0-.001 0-.001 0 0 0 .003.004.008.008.007l.006-.005c.003.002.01.004.01-.003.002.004.01.007.014 0 .006.004.01.004.014 0 .003.002.01.005.015 0 .003.004.008.005.013.002a.007.007 0 0 0 .01.002c.005.001.004.006.007.005.002-.001.007-.005.007-.008-.01.009-.008.003-.01 0-.005.003-.01.006-.014-.004-.005.006-.01.005-.01-.003-.003.003-.012.011-.017-.001-.002.007-.009.01-.015.003 0 .001-.007.01-.013 0-.003.007-.007.008-.012.001-.001.008-.008.01-.013.004zm.052-.044.001.001v.001h-.002l.001-.002zm0 .004.001.002v.001l-.002-.001.001-.002zm0 .004.001.001v.003c-.002 0-.003-.002-.003-.003h.002zm0 .005c.001 0 .003 0 .003.002l-.003.002s-.003 0-.003-.002l.003-.002zm.065.015c-.003 0-.004.002-.004.003s.001.002.004.002a.002.002 0 0 0 .002-.002L1.37 1.15zm.002-.007c-.002 0-.003 0-.003.002 0 .001 0 .002.003.002.001 0 .003 0 .003-.002l-.003-.002zm0-.006a.002.002 0 0 0-.002.002c0 .001 0 .003.002.003s.003-.002.003-.003c0 0 0-.002-.003-.002zm-.001-.007-.004.002c0 .002.003.003.004.003s.003-.001.003-.003l-.003-.002zm-.006-.006c-.002 0-.003.002-.003.004 0 .001 0 .002.003.002l.004-.002c0-.002-.003-.004-.004-.004zm-.007 0s-.003 0-.003.002l.003.002.004-.002c0-.002-.003-.003-.004-.003zm-.007-.002a.002.002 0 0 0-.002.002c0 .002.001.003.002.003.003 0 .004-.001.004-.003 0 0-.001-.002-.004-.002zm-.005-.001c-.003 0-.003.001-.003.003s0 .003.003.003c.002 0 .003-.001.003-.003s-.001-.003-.003-.003zm-.01.02v.004a.002.002 0 0 0 .003-.002.002.002 0 0 0-.003-.003Zm.003-.005a.002.002 0 0 0-.003.002l.003.001h.002a.002.002 0 0 0-.002-.003zm0-.006a.002.002 0 0 0-.002.002c0 .002.002.003.003.003 0 0 .003-.001.003-.003L1.34 1.13zm0-.006c-.002 0-.003 0-.003.002 0 0 .001.002.003.002s.003-.001.003-.002c0-.002-.001-.002-.003-.002zm-.005-.005c-.001 0-.003 0-.003.002l.003.003.003-.003-.003-.002zm-.007-.004c-.002 0-.003.002-.003.002 0 .003 0 .004.003.004.001 0 .002-.001.002-.004 0 0 0-.002-.002-.002zm-.007 0-.003.002c0 .002.002.003.003.003s.004-.001.004-.003l-.004-.002zm-.007 0a.002.002 0 0 0-.002.002c0 .002.001.003.002.003s.004-.001.004-.003l-.004-.002zm-.016 0 .002.002c0 .002 0 .003-.002.003s-.003-.001-.003-.003c0 0 0-.002.003-.002zm-.007 0 .003.002a.002.002 0 0 1-.003.003c-.002 0-.003-.001-.003-.003 0 0 0-.002.003-.002zm-.007 0 .003.002c0 .003-.002.004-.003.004 0 0-.003-.001-.003-.004l.003-.002zm-.007.004c.002 0 .003 0 .003.002 0 .001-.001.003-.003.003s-.003-.002-.003-.003.001-.002.003-.002zm-.005.005s.003 0 .003.002l-.003.002a.002.002 0 0 1-.003-.002c0-.002.002-.002.003-.002zm-.001.006c.002 0 .003.001.003.002 0 .002-.001.003-.003.003s-.002-.001-.002-.003c0 0 0-.002.002-.002zm.002.006.002.002-.002.001H1.27c0-.002 0-.003.002-.003zm.001.004.002.003a.002.002 0 0 1-.002.002.002.002 0 0 1-.002-.002c0-.001 0-.003.002-.003zm-.01-.02c.003 0 .004.002.004.004s-.001.003-.003.003a.002.002 0 0 1-.003-.003c0-.002.002-.003.003-.003zm-.005.002c.002 0 .003.001.003.002 0 .002 0 .003-.003.003-.001 0-.003-.001-.003-.003l.003-.002zm-.006.001c.001 0 .003.001.003.003a.002.002 0 0 1-.003.002c-.002 0-.003-.001-.003-.002 0-.002 0-.003.003-.003zm-.012.007.002.002a.002.002 0 0 1-.002.003c-.003 0-.004-.001-.004-.003 0 0 .001-.002.004-.002zm.005-.006c.001 0 .003.002.003.004a.002.002 0 0 1-.003.002c-.002 0-.003-.001-.003-.002 0-.002.001-.004.003-.004zm-.007.019c.002 0 .003 0 .003.002a.002.002 0 0 1-.003.002c-.002 0-.003 0-.003-.002 0-.001.001-.002.003-.002zm0-.006c.002 0 .003.001.003.002s-.001.003-.004.003a.002.002 0 0 1-.002-.003l.002-.002zm.003.013.002.003a.002.002 0 0 1-.002.002c-.001 0-.004 0-.004-.002l.004-.003zm.123.004-.002-.005c.013-.013-.006-.023-.019-.02v-.002c.012 0 .036.004.02.022l.002.005zm-.03-.008-.002-.007c.011-.013-.013-.022-.021-.015v-.002c.011-.007.036.005.022.018l.002.005zm-.022-.022c-.001.006-.004.013.001.016l-.005.005-.002-.001.005-.004c-.005-.004-.002-.013.001-.018zm-.014 0c.001.006.005.013 0 .016l.005.005v-.001l-.004-.004c.005-.004.002-.013 0-.018zm-.022.022.003-.007c-.012-.013.012-.022.02-.015v-.002c-.011-.007-.035.005-.023.018l-.002.005zm-.03.008.002-.005c-.013-.013.005-.023.02-.02v-.002c-.013 0-.036.004-.022.022l-.002.005zm.06-.048c.007.006.004.011 0 .016-.003-.003-.005-.005-.005-.008s0-.006.005-.008zm0 .01v-.012h.003v-.002h-.003V1.1h0v.002h-.004v.002h.003v.011h-.004v.001H1.31z",
    clipRule: "evenodd"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.372 1.161c-.003-.006-.01-.006-.013 0h-.004l-.001.001H1.35l.002.004-.002.001h.008c0-.007.01-.006.014-.006zm-.033.003-.002-.003h.006l-.004-.002.002-.004-.006.002.004-.007h-.004l-.002-.003-.002.004-.003-.002v.006h-.004v.002H1.32l.005.003-.003.001.007.001zm-.033-.006-.01.002.002-.003-.008-.003h.008l-.002-.004.006.002-.003-.008.004.002.002-.006.003.006.003-.003-.002.01.007-.002-.003.003.007.001-.007.003.001.003zm-.038.004.002-.002-.006-.001.004-.002-.002-.003h.006l-.004-.005h.005l.001-.003.002.003.003-.002-.001.007.005-.002v.003h.004l-.005.004.002.002h-.006zM1.24 1.16c.002-.005.009-.006.011 0 .001.002.002 0 .005-.001v.003h.004l-.002.003c.001 0 .002 0 .002.002 0-.001-.005-.002-.007-.001 0-.007-.01-.006-.013-.006z",
    clipRule: "evenodd"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.251 1.162c-.005 0-.005.002-.003.004s.004.001.004-.002v-.002z",
    clipRule: "evenodd"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.265 1.16c-.007 0-.001.007.001.002l-.001-.002z",
    clipRule: "evenodd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.275 1.154c-.002.003 0 .007.003.006.003-.002-.002-.006-.003-.006z",
    clipRule: "evenodd"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.291 1.155s-.003.002-.002.004c.005.003.006-.001.002-.004z",
    clipRule: "evenodd"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "m1.306 1.153-.003.001c0 .003.003.005.006.001a.002.002 0 0 0-.003-.002z",
    clipRule: "evenodd"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.32 1.157c-.007 0 0 .005.002.002 0-.001 0-.002-.002-.002z",
    clipRule: "evenodd"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.333 1.157c.002 0 .001.005-.004.004-.002 0 .002-.006.004-.004z",
    clipRule: "evenodd"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.347 1.161c.005 0 0 .007-.003.003 0-.002 0-.003.003-.003z",
    clipRule: "evenodd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.36 1.165c.004 0 .005 0 .004.003-.002.001-.006 0-.006-.003z",
    clipRule: "evenodd"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.272 1.176h.003a.002.002 0 0 1-.002.002c-.001.002-.002 0-.002 0v-.002zm.065 0h-.002l.002.002c0 .002.002 0 .002 0s0-.002-.002-.002zm-.043-.002.002.001-.002.001-.001-.001zm.023-.001h-.003c0 .002.002.003.003.003v-.003z",
    clipRule: "evenodd"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#33a457",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "m1.283 1.174.006.001-.006.002h-.005l.005-.003zm.045 0-.007.001.006.002h.006z",
    clipRule: "evenodd"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.306 1.173h.006c0 .002-.003.003-.006.003s-.007 0-.007-.002l.007-.001zm-.042.003-.003.004.004.002.002-.004zm.084 0 .002.004-.003.002-.004-.004z",
    clipRule: "evenodd"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.005872,
    d: "M.46 1.185c0 .01.078.01.08 0-.005-.011-.08-.01-.08 0z",
    clipRule: "evenodd"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.003456,
    d: "M.558 1.146c0-.009-.017-.015-.027-.007-.006-.008-.02-.012-.032-.005-.007-.007-.024-.006-.03.004-.01-.007-.027-.001-.027.01.007.028.013.026.016.025a.202.202 0 0 1 .083 0c.009.002.015-.013.017-.027z",
    clipRule: "evenodd"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.005872,
    d: "M.462 1.185c.01-.009.068-.005.073 0 0 .007-.075.006-.073 0z",
    clipRule: "evenodd"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.005872,
    d: "m.54 1.184.001-.008a.188.188 0 0 0-.084 0l.001.008c.005-.01.078-.009.081 0z",
    clipRule: "evenodd"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.456 1.172c-.001 0-.002.003.002.003a.196.196 0 0 1 .082 0h.003L.54 1.173a.26.26 0 0 0-.084-.001zm-.009-.006H.446c0 .003.006.008.009.007l.006-.005c.002.002.01.004.01-.003.002.004.01.007.015 0 .005.004.01.004.013 0 .002.002.01.005.015 0 .003.004.008.005.012.002.003.003.007.005.012.002.003.001.002.006.006.005.002-.001.007-.005.007-.008-.01.009-.008.003-.01 0-.005.003-.011.006-.015-.004-.004.006-.008.005-.01-.003-.002.003-.011.011-.016-.001-.002.007-.01.01-.014.003-.001.001-.008.01-.015 0-.002.007-.006.008-.01.001-.003.008-.01.01-.014.004zm.052-.044.001.001-.001.001H.498v-.002zm0 .004.001.002-.001.001-.001-.001v-.002zm0 .004.002.001-.002.003-.001-.003s0 0 0 0zm0 .005c.002 0 .003 0 .003.002 0 .001 0 .002-.003.002-.001 0-.003 0-.003-.002L.5 1.135zm.064.015-.002.003.002.002c.001 0 .004 0 .004-.002L.563 1.15zm.003-.007a.002.002 0 0 0-.003.002c0 .001.001.002.003.002s.003 0 .003-.002c0-.001-.001-.002-.003-.002zm0-.006c-.002 0-.003.001-.003.002s.001.003.004.003l.003-.003-.003-.002zM.565 1.13a.002.002 0 0 0-.002.002c0 .002.001.003.002.003.003 0 .004-.001.004-.003 0 0-.001-.002-.004-.002zM.56 1.124c-.003 0-.003.002-.003.004 0 .001 0 .002.003.002.002 0 .003-.001.003-.002 0-.002-.001-.004-.003-.004zm-.007 0a.002.002 0 0 0-.002.002s0 .002.002.002.003-.001.003-.002c0-.002 0-.003-.003-.003zm-.006-.002c-.002 0-.003.001-.003.002 0 .002 0 .003.003.003.001 0 .004-.001.004-.003l-.004-.002zM.54 1.121c-.002 0-.003.001-.003.003s.001.003.003.003a.002.002 0 0 0 .003-.003c0-.002-.002-.003-.003-.003zm-.009.02a.002.002 0 0 0-.002.002s0 .002.002.002a.002.002 0 0 0 .002-.002.002.002 0 0 0-.002-.003zm.001-.005a.002.002 0 0 0-.002.002l.002.001h.003a.002.002 0 0 0-.003-.003zm.003-.006c-.003 0-.004.001-.004.002 0 .002.001.003.004.003 0 0 .002-.001.002-.003L.535 1.13zm-.002-.006c-.002 0-.003 0-.003.002 0 0 .001.002.003.002a.002.002 0 0 0 .003-.002c0-.002-.001-.002-.003-.002zM.528 1.12c-.002 0-.003 0-.003.002 0 .001.001.003.003.003s.003-.002.003-.003-.001-.002-.003-.002zM.52 1.115l-.003.002c0 .003.002.004.003.004 0 0 .003-.001.003-.004l-.003-.002zm-.007 0a.002.002 0 0 0-.003.002c0 .002.002.003.003.003.002 0 .003-.001.003-.003 0 0 0-.002-.003-.002zm-.007 0a.002.002 0 0 0-.002.002c0 .002 0 .003.002.003s.003-.001.003-.003c0 0 0-.002-.003-.002zm-.016 0 .002.002a.002.002 0 0 1-.002.003c-.001 0-.004-.001-.004-.003l.004-.002zm-.007 0c.002 0 .003.001.003.002 0 .002 0 .003-.003.003a.002.002 0 0 1-.002-.003s0-.002.002-.002zm-.007 0c.002 0 .003.002.003.002 0 .003 0 .004-.003.004-.001 0-.002-.001-.002-.004 0 0 0-.002.002-.002zM.47 1.12c.002 0 .003 0 .003.002 0 .001 0 .003-.003.003-.002 0-.002-.002-.002-.003s0-.002.002-.002zm-.005.005c.002 0 .003 0 .003.002a.002.002 0 0 1-.003.002c-.002 0-.003-.001-.003-.002 0-.002.001-.002.003-.002zm0 .006.002.002a.002.002 0 0 1-.003.003.002.002 0 0 1-.002-.003l.002-.002zm0 .006c.002 0 .003.001.003.002l-.003.001s0 0 0 0v-.003zm.003.004v.005a.002.002 0 0 1-.003-.002l.003-.003zm-.01-.02c.003 0 .003.002.003.004s0 .003-.003.003c0 0-.003-.001-.003-.003s.002-.003.003-.003zm-.005.002.002.002a.002.002 0 0 1-.002.003c-.003 0-.004-.001-.004-.003 0 0 .001-.002.004-.002zm-.007.001c.001 0 .003.001.003.003l-.003.002-.004-.002c0-.002.003-.003.004-.003zm-.013.007.004.002c0 .002-.003.003-.004.003-.002 0-.002-.001-.002-.003 0 0 0-.002.002-.002zm.006-.006c.002 0 .003.002.003.004 0 .001 0 .002-.003.002a.002.002 0 0 1-.002-.002c0-.002 0-.004.002-.004zm-.007.019c.002 0 .003 0 .003.002 0 .001 0 .002-.003.002a.002.002 0 0 1-.002-.002c0-.001 0-.002.002-.002zm-.001-.006c.002 0 .003.001.003.002s0 .003-.003.003l-.002-.003s0-.002.002-.002zm.003.013c.003 0 .004.002.004.003s-.001.002-.004.002c0 0-.003 0-.003-.002l.003-.003zm.124.004L.556 1.15c.013-.013-.006-.023-.02-.02v-.002c.014 0 .037.004.02.022l.004.005zm-.03-.008L.525 1.14c.013-.013-.012-.022-.02-.015v-.002c.011-.007.035.005.023.018l.002.005zm-.022-.022c-.001.006-.005.013 0 .016l-.004.005v-.001l.003-.004c-.004-.004-.002-.013 0-.018zm-.014 0c.001.006.005.013-.001.016l.006.005v-.001L.494 1.14c.005-.004.002-.013-.001-.018zm-.022.022.002-.007c-.011-.013.013-.022.021-.015v-.002c-.011-.007-.036.005-.022.018l-.003.005zm-.03.008.002-.005c-.012-.013.006-.023.019-.02v-.002c-.012 0-.036.004-.02.022l-.003.005zm.06-.048c.008.006.005.011 0 .016-.002-.003-.005-.005-.006-.008A.013.013 0 0 1 .5 1.106zm0 .01v-.012h.003v-.002H.5V1.1H.499v.002H.496v.002H.5v.011H.494l.001.001h.01z",
    clipRule: "evenodd"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.566 1.161a.007.007 0 0 0-.013 0H.548c.002 0 .002.001 0 .001H.545l.002.004-.003.001h.008c0-.007.01-.006.014-.006zm-.033.003V1.16h.004l-.005-.002.003-.004-.006.002.003-.007H.53l-.001-.003-.004.004-.002-.002.001.006H.518l.002.002H.514l.004.003v.001l.005.001zM.5 1.158l-.01.002.002-.003-.008-.003h.008L.49 1.15l.007.002-.004-.008.005.002V1.14l.003.006.004-.003-.002.01.007-.002-.003.003.007.001-.007.003.002.003zm-.037.004V1.16L.458 1.16l.005-.002-.003-.003h.007L.463 1.15h.004v-.003l.003.003.003-.002v.007l.004-.002-.001.003H.48l-.004.004.002.002H.471zm-.03-.003c.004-.005.01-.006.013 0 0 .002.002 0 .004-.001 0 .002 0 .002.002.003h.002l-.002.003s.002 0 .002.002c-.001-.001-.005-.002-.007-.001 0-.007-.01-.006-.014-.006z",
    clipRule: "evenodd"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.446 1.162c-.005 0-.006.002-.005.004.003.002.005.001.005-.002z",
    clipRule: "evenodd"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.458 1.16c-.005 0 0 .007.003.002 0 0-.001-.002-.003-.002z",
    clipRule: "evenodd"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.469 1.154c-.002.003-.001.007.003.006.003-.002-.002-.006-.003-.006z",
    clipRule: "evenodd"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.486 1.155a.003.003 0 0 0-.003.004c.004.003.005-.001.003-.004z",
    clipRule: "evenodd"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.501 1.153c-.001-.001-.003 0-.004.001 0 .003.004.005.005.001v-.002z",
    clipRule: "evenodd"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.515 1.157c-.007 0 0 .005.002.002l-.002-.002z",
    clipRule: "evenodd"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.526 1.157c.003 0 .002.005-.003.004-.002 0 .002-.006.003-.004z",
    clipRule: "evenodd"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.54 1.161c.007 0 .001.007 0 .003V1.16z",
    clipRule: "evenodd"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.554 1.165c.004 0 .005 0 .004.003-.002.001-.005 0-.005-.003z",
    clipRule: "evenodd"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.467 1.176h.002a.002.002 0 0 1-.002.002c-.002.002-.003 0-.003 0s.001-.002.003-.002zm.065 0H.53l.001.002c.001.002.002 0 .002 0zm-.044-.002.002.001-.002.001-.002-.001.002-.001zm.022-.001h0v.003c.001 0 .003 0 .003-.002L.51 1.173z",
    clipRule: "evenodd"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#33a457",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "m.477 1.174.006.001-.005.002H.472zm.045 0-.006.001.005.002h.007l-.006-.003z",
    clipRule: "evenodd"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.5 1.173h.006c0 .002-.003.003-.006.003s-.006 0-.006-.002L.5 1.173zm-.043.003-.002.004.003.002.003-.004zm.084 0 .003.004-.004.002-.002-.004z",
    clipRule: "evenodd"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.003456,
    d: "M.897 1.5h.283v.23c.004.06-.08.086-.133.106a.27.27 0 0 1-.15-.106z",
    clipRule: "evenodd"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.000528,
    d: "M1.031 1.543h.014l.008.008v.026l-.007.008H1.03l-.007-.008v-.025zm.09-.027v.014l-.008.008h-.028l-.007-.007v-.015l.007-.008h.027zm-.113 0v.015l-.01.008H.973l-.007-.007v-.016l.007-.007H1zm-.084.042h.014l.008.008v.026L.939 1.6H.923l-.007-.007v-.025Zm.045.008.009-.01.013-.002.02.017v.01l-.01.012h-.01l-.019-.016zm.146-.003-.01-.01h-.012l-.02.016v.01l.01.012h.01l.02-.015zm.02-.005h.015l.008.008v.026L1.15 1.6h-.016l-.008-.007v-.025Zm-.014.054v.013l-.008.009h-.028l-.007-.007V1.61l.007-.006h.027zm-.113-.003v.015l-.01.008H.973l-.007-.007V1.61l.007-.008H1zm-.084.027h.014l.009.01v.027l-.008.005H.923l-.007-.006v-.027zm.085.015L1 1.64H.988l-.02.017v.009l.011.013h.01l.02-.016Zm.064.003.009-.011.011-.001.021.017v.01l-.01.013h-.01l-.02-.016zm.063-.018h.014l.008.008v.026l-.007.008h-.016l-.007-.008v-.026zm-.106.048h.014l.008.008v.027l-.007.007h-.016l-.007-.007v-.027zm.096.074-.007-.013-.012-.003-.024.012-.001.01.007.015.01.002.022-.013zm-.165.007.006-.013.011-.003.024.01.004.01-.007.014-.01.004-.022-.01z",
    clipRule: "evenodd"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.135 1.708.938 1.54v.073h.197v-.066l-.194.166c0 .028.046.06.09.06v-.241l-.08-.001.184.157v-.064H.938v.067l.19-.16h-.083v.24c.044.002.09-.032.09-.062zm.015-.19v.185c-.001.05-.06.081-.11.081s-.116-.03-.116-.073v-.194Z",
    clipRule: "evenodd"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#598376",
    fillRule: "evenodd",
    d: "M1.038 1.596c.011 0 .022.01.022.023 0 .012-.01.023-.022.023-.013 0-.022-.01-.022-.023s.01-.023.022-.023z",
    clipRule: "evenodd"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.14 1.605c.009 0 .014.004.014.012 0 .007-.005.013-.014.013-.008 0-.013-.006-.013-.013 0-.008.005-.012.013-.012zm-.1-.092c.006 0 .013.004.013.012 0 .007-.007.013-.014.013-.008 0-.014-.006-.014-.013 0-.008.006-.012.014-.012zm-.002.25c.008 0 .014.005.014.013 0 .007-.006.013-.014.013s-.014-.006-.014-.013c0-.008.006-.012.014-.012zM.93 1.607c.008 0 .013.006.013.013a.013.013 0 0 1-.013.013c-.007 0-.013-.005-.013-.013a.013.013 0 0 1 .013-.013z",
    clipRule: "evenodd"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.000528,
    d: "M1.002 1.518v.012l-.006.006h-.02L.97 1.53v-.013l.007-.004h.018zm.113 0v.01l-.006.006h-.02l-.006-.004v-.014l.007-.005h.018zm.02.044h.012l.006.006v.022l-.004.004h-.013L1.13 1.59v-.02zm-.026.004-.007-.008-.009-.002-.015.014v.007l.007.01h.008l.014-.012zm-.077-.019h.012l.005.006v.022l-.004.004H1.03l-.005-.005v-.02zm-.057.02.007-.007.009-.001.015.013v.007L1 1.59H.99l-.014-.013zm-.05-.005h.012l.005.006v.022l-.005.004H.925L.92 1.59v-.02zm.077.05v.01l-.006.006h-.02L.97 1.623V1.61l.007-.004h.018zm.113 0v.012l-.006.006h-.02l-.006-.006v-.011l.007-.006h.018zm-.039.043.008-.008h.01l.014.012.003.008-.01.01h-.007l-.015-.012zm.061-.013h.012l.005.005v.02l-.004.006h-.014l-.005-.006v-.02zm-.212 0h.012l.005.005v.021l-.005.005H.925L.92 1.667v-.018zm.08.011-.009-.008-.008-.001-.015.014v.007l.006.01h.01l.013-.013zm.026.036h.01l.007.006v.02l-.005.006H1.03l-.005-.006v-.02zm.09.07-.006-.01-.01-.003-.016.01-.003.007.006.011.007.002.017-.009zm-.154.007.004-.01.008-.004.019.008.002.007-.005.012-.007.002-.018-.008z",
    clipRule: "evenodd"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "m.896 1.2.001.53c-.036.057-.06.086-.15.102m-.115-.333h.548m0 .237V1.2H.632v.53c.032.096.187.13.26.13.076 0 .291-.039.288-.124z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc2229",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.9 1.394c.045 0 .082.048.082.107 0 .06-.037.108-.082.108-.045 0-.082-.048-.082-.108 0-.059.037-.107.082-.107z",
    clipRule: "evenodd"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.899 1.426c.032 0 .058.034.058.075 0 .043-.026.077-.058.077S.84 1.544.84 1.501c0-.041.026-.075.058-.075z",
    clipRule: "evenodd"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.873 1.504c.01 0 .013-.012.01-.014-.003-.003 0-.005 0-.006.003-.005.011-.005.014 0 0-.01-.008-.018-.016-.012 0-.007 0-.02-.008-.025-.007.006-.008.018-.007.025-.009-.003-.017.001-.017.012.005-.005.012-.005.015 0 .001 0 .003.003 0 .006-.003.002 0 .014.01.014zm.052 0c.01 0 .012-.012.008-.014-.002-.003 0-.005.001-.006.003-.005.01-.005.015 0 0-.01-.008-.018-.017-.012.001-.007 0-.02-.007-.025-.008.006-.008.018-.008.025C.907 1.47.9 1.473.9 1.484c.004-.005.012-.005.015 0 0 0 .003.003 0 .006-.004.002 0 .014.01.014zm-.028.065c.01 0 .013-.012.01-.015-.003-.001 0-.005 0-.006.003-.003.011-.003.016 0 0-.01-.01-.017-.018-.01 0-.007 0-.02-.008-.027-.007.006-.007.02-.007.027-.009-.004-.017 0-.017.01.005-.003.013-.003.015 0 .001.001.004.005.001.006-.004.002 0 .015.008.015z",
    clipRule: "evenodd"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.899 1.73c.008.016.066.09.154.105"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M.766 1.403h.001a.026.026 0 0 1 .027.027v.032H.738V1.43c0-.015.013-.027.028-.027z",
    clipRule: "evenodd"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#505e86",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0037440000000000004,
    d: "M.766 1.41h.001c.012 0 .02.01.02.02v.033H.745v-.032a.02.02 0 0 1 .021-.02z",
    clipRule: "evenodd"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "m.781 1.418.008-.01c.006.004.008.011.008.016l-.012.001zm-.025-.016a.029.029 0 0 1 .004.01h.014l.005-.01a.027.027 0 0 0-.023 0zm-.004.017-.008-.011c-.003.004-.007.008-.008.016H.75l.002-.005z",
    clipRule: "evenodd"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#ca0088",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.005872,
    d: "M1.025 1.243c0 .006.005.01.01.015-.019.006-.024-.003-.033-.015 0 .007 0 .008.004.014.009.011.015.016.033.015v.015c-.015.007-.03-.007-.04-.016-.004-.006-.004-.007-.01-.026-.004-.008-.032-.007-.035.003.004-.002.011-.004.015 0-.006 0-.022.002-.022.016.003-.005.017-.003.022-.003-.01.004-.019.003-.016.015.02-.011.018.014.026.02.013.008.024.005.032.02-.004.004-.012.011-.012.02-.028-.022-.04-.002-.04.004.005 0 .012-.004.017 0-.013.007-.021.015-.012.034.003-.005.01-.02.018-.02-.017.016.008.033.017.033-.013-.006-.008-.033.01-.033.001 0 .001.004.006.006.01 0 .003-.014.015-.017.001.012.011.02.028.019.006 0 .012.005.016.01-.008.01-.028-.013-.034.001-.004.01 0 .017.01.034-.003.004-.01.003-.013-.002-.007-.016-.043-.003-.042.012.004-.005.013-.006.018-.005-.013 0-.012.023-.005.03.001-.008.005-.016.013-.017 0 .007-.004.008-.007.015-.006.01-.005.024.008.024-.004-.003-.002-.018.01-.018.013-.004.019.012.023.004a.117.117 0 0 0 .02-.054c-.001.015.017.032.022.032.007.002.017.006.012.014-.008.007-.039-.002-.041.023a.038.038 0 0 1 .023-.007c-.008.006-.01.014-.002.023.004-.012.011-.01.012-.013.012 0 .018 0 .018.017.013-.008.007-.025.005-.033.013-.019.025-.036.013-.039-.005 0-.015-.004-.017-.009a.076.076 0 0 1-.004-.029c.015.01.019.005.028-.003.012-.01-.001-.07-.007-.089.005-.022.015-.017.022-.034l-.01.003.007-.02-.02.013v-.01c-.016.013-.006.036-.007.045 0 0 .016.082.003.086-.003.01-.025-.002-.028-.011-.003-.003-.005-.01-.005-.023.002 0-.005-.031-.003-.034.002 0 .01.005.016.016.003-.015-.012-.027-.012-.03 0-.004.013.004.018.014 0-.008-.002-.02-.015-.025-.002-.005.01-.001.018.01-.002-.016-.017-.024-.02-.025-.016-.022-.025-.024-.038-.028-.015.006-.018.01-.038.013z",
    clipRule: "evenodd"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.005872,
    d: "M1.04 1.287a.104.104 0 0 1-.029.03m.003 0c-.007.008-.005.014 0 .02.003-.011.011-.016.02-.02-.006.016.009.017.015.024-.009-.01.004-.02.004-.027.001.003.006.027.024.025-.006-.007-.003-.025-.003-.03.002.002.018.007.025.025"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.038 1.273c.022-.008.01-.018-.004-.014.007-.001.02.004.004.014z",
    clipRule: "evenodd"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0016,
    d: "M1.062 1.251c-.001-.001-.016-.002-.017-.005.007-.003.013-.005.017.005z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/spain.28769b91d5b4b8c4689b6e2b45dd464e.svg";
export { ForwardRef as ReactComponent };